import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableColumnManagementComponent } from './table-column-management.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { SharedModule } from '@uw/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [CommonModule, MatSelectModule, MatButtonModule, FormsModule, ReactiveFormsModule, CustomMaterialModule, TranslateModule, SharedModule, TableColumnManagementComponent],
    exports: [TableColumnManagementComponent],
})
export class TableColumnManagementModule {}
